import { createTheme } from '@mui/material_v7/styles';

const typographyTheme = createTheme({
  typography: {
    fontFamily: '"Helvetica Neue", Arial, sans-serif',
    h1: {
      fontSize: 24,
      lineHeight: '28px',
      fontWeight: 700,
    },
    h2: {
      fontSize: 24,
      lineHeight: '28px',
      fontWeight: 400,
    },
    h3: {
      fontSize: 20,
      lineHeight: '24px',
      fontWeight: 700,
    },
    h4: {
      fontSize: 20,
      lineHeight: '24px',
      fontWeight: 400,
    },
    h5: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 700,
    },
    h6: {
      fontSize: 16,
      lineHeight: '20px',
      fontWeight: 400,
    },
    subtitle1: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 700,
    },
    subtitle2: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 400,
    },
    body1: {
      fontSize: 16,
      lineHeight: '24px',
      fontWeight: 400,
    },
    body2: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
    },
    body3: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 700,
    },
    label1: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
    },
    label2: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 400,
    },
    label3: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 700,
    },
    caption1: {
      fontSize: 14,
      lineHeight: '20px',
      fontWeight: 400,
    },
    caption2: {
      fontSize: 12,
      lineHeight: '16px',
      fontWeight: 400,
    },
  },
});

export default typographyTheme;
